import { createFilter, Operator } from '../Common/Filter/Data';

export const TABLE_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_TIME = 500;
export const CALL_COLUMN = 'Call';
export const CALLER_COLUMN = 'Caller';
export const REASON_COLUMN = 'Reason for call';
export const START_TIME_COLUMN = 'Start time';
export const DURATION_COLUMN = 'Duration';
export const CUSTOMER_CALL_LOG_COLUMNS = [CALL_COLUMN, REASON_COLUMN, START_TIME_COLUMN, DURATION_COLUMN];
export const GLOBAL_CALL_LOG_COLUMNS = [CALL_COLUMN, CALLER_COLUMN, REASON_COLUMN, START_TIME_COLUMN, DURATION_COLUMN];
export const CONNECTING_DIALOG_CLOSE_TIME = 5000;

export const EMPTY_STATE_NO_SEARCH_RESULTS = 'No calls matching your query';
export const CALL_TYPE_MISSED = 'Missed';
const CALL_TYPE_INBOUND = 'Inbound';
const CALL_TYPE_OUTBOUND = 'Outbound';
export const CALL_TYPE_ALL = 'All';
export const CALL_TYPES = [CALL_TYPE_ALL, CALL_TYPE_MISSED, CALL_TYPE_INBOUND, CALL_TYPE_OUTBOUND];
export const START_TAB = CALL_TYPE_ALL;
export const EMPTY_STATE_MESSAGES = {
  [CALL_TYPE_MISSED]: 'No missed calls',
  [CALL_TYPE_INBOUND]: 'No inbound calls',
  [CALL_TYPE_OUTBOUND]: 'No outbound calls',
  [CALL_TYPE_ALL]: 'No calls',
};
export const CALL_LOGS_COLUMN_SORT_MAP = {
  [CALLER_COLUMN]: 'display_caller_name',
  [REASON_COLUMN]: 'reason',
  [START_TIME_COLUMN]: 'started_at',
};

export const DESTINATION_NUMBER = 'destination_number';
export const LEAD_SOURCE_NAME = 'name';
export const TWILIO_PHONE_NUMBER = 'phone_number';

export const VALID_MASKED_PHONE_NUMBER_LENGTH = 14;
export const CALL_TRACKING_TITLE = 'New call tracking number';

export const CREATE_VARIANT = 'create';
export const EDIT_VARIANT = 'edit';
export const DELETE_VARIANT = 'delete';

export const CALL_LOGS_PAGINATION_ID = 'call_logs';

export const formatDuration = (duration) => {
  if (!duration) return '';
  if (duration < 60) return `${duration}s`;
  return `${Math.floor(duration / 60)}m ${duration % 60}s`;
};

export const GLOBAL_CALL_LOG_BUTTON_LABEL = 'global call log';
export const CUSTOMER_CALL_LOG_BUTTON_LABEL = 'customer call log';
export const EDIT_CALLER_BUTTON_NAME = 'Edit caller';
export const ESTIMATE_BUTTON_NAME = 'Estimate';
export const JOB_BUTTON_NAME = 'Job';
export const LEAD_BUTTON_NAME = 'Lead';
export const CUSTOMER_PROFILE_BUTTON_NAME = 'Customer profile';
export const OUTBOUND_CALL_BUTTON_NAME = 'Outbound call';

export const FILTER_DISPLAY_STATUS = 'display_status';
export const FILTER_HAS_RECORDING = 'has_recording';
export const FILTER_HAS_VOICEMAIL = 'has_voicemail';

export const CALL_LOG_TAB_ALL = 'All';
export const CALL_LOG_TAB_MISSED = 'Missed';
export const CALL_LOG_TAB_INBOUND = 'Inbound';
export const CALL_LOG_TAB_OUTBOUND = 'Outbound';
export const CALL_LOG_EXISTING_CUSTOMER = 'Existing customer';
export const CALL_LOG_CREATE_NEW_CUSTOMER = 'Create new customer';
export const CANCEL_BUTTON_NAME = 'Cancel';
export const CALL_DETAILS_PLAY_RECORDING = 'Play recording';
export const CALL_DETAILS_PLAY_VOICEMAIL = 'Play voicemail';
export const CALL_DETAILS_EDIT_CALL_NOTES = 'Edit call notes';

export const CALL_LOG_FILTER_MAP = {
  All: [],
  Missed: [createFilter('display_status', Operator.EQUAL_TO, ['missed'])],
  Outbound: [
    createFilter('display_status', Operator.EQUAL_TO, ['in_progress', 'completed']),
    createFilter('display_direction', Operator.EQUAL_TO, ['outbound']),
  ],
  Inbound: [
    createFilter('display_status', Operator.EQUAL_TO, ['in_progress', 'completed']),
    createFilter('display_direction', Operator.EQUAL_TO, ['inbound']),
  ],
};
